import script from "./Game.vue?vue&type=script&setup=true&lang=ts"
export * from "./Game.vue?vue&type=script&setup=true&lang=ts"

import "./Game.vue?vue&type=style&index=0&id=b4e31dc4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4e31dc4"]])

export default __exports__